module.exports = __webpack_public_path__ + "static/media/2013.265205f7.svg";